import { FC, Fragment } from 'react';

import classNames from 'classnames';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import Link, { LinkAppearance, LinkKind } from 'bloko/blocks/link';
import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { setQuizVisible } from 'store/models/quiz';
import { useDispatch, useSelector } from 'store/utils';

import 'components/common/Message/Message.less';

export const Message: FC = () => {
    const { data, isMessageVisible: isQuizMessageVisible } = useSelector((state) => state.quiz);

    const dispatch = useDispatch();

    const trl = useTrls();

    const quizMessage = data?.message;

    const isSuccess = trl('header.message.success.title') || trl('header.message.success.text');
    const isError = trl('header.message.error.title') || trl('header.message.error.text');

    if ((!isSuccess && !isError && !isQuizMessageVisible) || (isQuizMessageVisible && !quizMessage)) {
        return null;
    }

    return (
        <div
            className={classNames(
                'message',
                { [`message_success`]: isSuccess },
                { [`message_error`]: isError || isQuizMessageVisible }
            )}
        >
            <ColumnsWrapper>
                <ColumnsRow>
                    <Column xs="4" s="8" m="12" l="16">
                        <VSpacing base={4} />
                        {isError && (
                            <Fragment>
                                <Text strong>{trl('header.message.error.title')}</Text>
                                <Text>{trl('header.message.error.text')}</Text>
                            </Fragment>
                        )}
                        {isSuccess && (
                            <Fragment>
                                <Text strong>{trl('header.message.success.title')}</Text>
                                <Text>{trl('header.message.success.text')}</Text>
                            </Fragment>
                        )}
                        {isQuizMessageVisible && quizMessage && (
                            <Fragment>
                                <Text strong>{quizMessage.title}</Text>
                                <Text Element="span">{quizMessage.description}</Text>{' '}
                                <Link
                                    appearance={LinkAppearance.Pseudo}
                                    kind={LinkKind.Inversed}
                                    onClick={() => dispatch(setQuizVisible(true))}
                                >
                                    {quizMessage.trigger}
                                </Link>
                            </Fragment>
                        )}
                        <VSpacing base={4} />
                    </Column>
                </ColumnsRow>
            </ColumnsWrapper>
        </div>
    );
};
